module.exports = __webpack_public_path__ + "img/nav-instructions.bc6cc8cb.svg";